import DsfUserHome from '../views/DsfUserHome';
import ExamPage from '../views/DsfExamPage';
import DsfExamPaperAdd from '../views/DsfExamPaperAdd';
import DsfExamMarking from '../views/DsfExamMarking';
import ExportTestPaper from '../views/ExportTestPaper';
import ExamStatus from '../views/ExamStatus.vue';
import DsfExamRecord from '../views/DsfExamRecord';
import ExamResult from '../views/ExamResult.vue';
import DsfExamPractice from '../views/DsfExamPractice';
import DsfExamWrongExercise from '../views/ExamWrongExercise';
import DsfErrorTips from '../views/ErrorTips';
import DsfExamEntrance from '../views/DsfExamEntrance';
import DsfPracticeResult from '../views/DsfPracticeResult';
import DsfAddQuestion from '../views/DsfAddQuestion';
import TransferPage from '../views/TransferPage';

let router = [
  {
    path: "/pc/exam/user-home",
    meta: {
      title: "考试首页",
      needLogin: true
    },
    component: DsfUserHome
  },
  {
    path: "/pc/exam/exam",
    meta: {
      title: "考试",
      needLogin: true
    },
    component: ExamPage
  },
  {
    path: "/pc/exam/add-exam-paper",
    meta: {
      title: "新增试卷",
      needLogin: true
    },
    component: DsfExamPaperAdd
  },
  {
    path: "/pc/exam/export-test-paper",
    meta: {
      title: "导出试卷",
      needLogin: true
    },
    component: ExportTestPaper
  },
  {
    path: "/pc/exam/exam-marking",
    meta: {
      title: "阅卷",
      needLogin: true
    },
    component: DsfExamMarking
  },
  {
    path: "/pc/exam/check-exam-status",
    meta: {
      title: "查看考试状态",
      needLogin: true
    },
    component: ExamStatus
  }, {
    path: "/pc/exam/check-exam-result",
    meta: {
      title: "查看考试结果",
      needLogin: true
    },
    component: ExamResult
  },
  {
    path: "/pc/exam/exam-record",
    meta: {
      title: "查看考试详情",
      needLogin: true
    },
    component: DsfExamRecord
  },
  {
    path: "/pc/exam/exam-practice",
    meta: {
      title: "练习",
      needLogin: true
    },
    component: DsfExamPractice
  },
  {
    path: "/pc/exam/practice-result",
    meta: {
      title: "练习结果",
      needLogin: true
    },
    component: DsfPracticeResult
  },
  {
    path: "/pc/exam/wrong-exercise",
    meta: {
      title: "错题练习",
      needLogin: false
    },
    component: DsfExamWrongExercise
  },
  {
    path: "/pc/exam/examentrance",
    meta: {
      title: "考试入口",
      needLogin: false
    },
    component: DsfExamEntrance
  },

  {
    path: "/pc/exam/error",
    meta: {
      title: "错误页面",
      needLogin: false
    },
    component: DsfErrorTips
  },
  {
    path: "/pc/exam/add-question",
    meta: {
      title: "新增试题",
      needLogin: true
    },
    component: DsfAddQuestion
  },
  {
    path: "/pc/exam/transfer-page",
    meta: {
      title: "",
      needLogin: true
    },
    component: TransferPage
  },
];

export default router;